__turbopack_context__.v({
  "addItemButton": "k1ybgG_addItemButton",
  "bottomBar": "k1ybgG_bottomBar",
  "bottomBarNoInstallments": "k1ybgG_bottomBarNoInstallments",
  "container": "k1ybgG_container",
  "labelContainer": "k1ybgG_labelContainer",
});
